import PageHead from "@/components/header/PageHead";
import PoolChangeControlComponent from '@/components/subpool/change/PoolChangeControlComponent';
import { getPrefix } from "@/utils/common";
export default {
  name: "PoolChangeControl",
  components: {
    PageHead,
    PoolChangeControlComponent
  },
  data() {
    return {
      nodeId: '',
      poolAddress: ''
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.nodeId = getPrefix() + this.$route.params.provider;
      this.poolAddress = this.$route.params.poolAddress;
      this.$store.dispatch('getNodePublicInfo', {
        nodeId: this.nodeId
      });
    }
  },
  computed: {
    docsUrlPrefix() {
      return `https://docs.stfil.io/${this.$i18n.locale === "zh" ? 'v/cn/' : ''}`;
    }
  }
};